<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} PERMISSION</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- <template v-if="dataImg">

          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataImg" alt="img" class="responsive">
          </div>

          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Update Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataImg = null">Remove Image</vs-button>
          </div>
        </template> -->

        <!-- NAME -->
        <vs-input label="Name*" v-model="dataName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
         <vs-input label="Display Name" v-model="dataDisplayName" class="mt-5 w-full mb-base" />
         <label class="vs-select--label w-full">Description</label>
        <vs-textarea  v-model="dataAbout" rows="5" />
        </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {ADD_NEW_PERMISSION} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {

      dataId: null,
      dataName:null,
      dataDisplayName:null,
      dataAbout:null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name, is_temp} = JSON.parse(JSON.stringify(this.data))
        // this.dataId = id
        // this.dataName = name
        // this.is_temp = is_temp
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    StatusSuccess () {
      this.$vs.notify({
        title: 'Permission',
        text: 'Add Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail (msg) {
      this.$vs.notify({
        title: 'Permission',
        text: msg,
        color: 'danger',
        position: 'top-right'
      })
    },
    initValues () {
      this.dataId = null
      this.dataName = null
      this.dataDisplayName = null
      this.dataAbout = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            // this.$apollo
            //   .mutate({
            //     mutation: EDIT_NEWSLETTER_TEMPLATE,
            //     variables: {
            //       id:this.dataId,  
            //       name:  this.dataName,
            //       is_temp: this.is_temp
            //     }
            //   })
            //   .then(response => {
            //     if (response.data.editNewsletterTemplate.status == 'Success') {
            //       this.StatusSuccess(response.data.editNewsletterTemplate.message)
            //       this.$emit('closeSidebar')
            //       this.initValues()
            //       this.$emit('getdata')
            //     } else {
            //       this.StatusFail()
            //     }
            //   }).catch(error => {
            //     console.log(error)
            //     this.StatusFail()
            //   })
          } else {
            this.$apollo
              .mutate({
                mutation: ADD_NEW_PERMISSION,
                variables: {
                  name:  this.dataName,
                  display:  this.dataDisplayName,
                  about:  this.dataAbout
                }
              })
              .then(response => {
                if (response.data.addNewPermission.status == 'Success') {
                  this.StatusSuccess(response.data.addNewPermission.message)
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.$emit('getdata')
                }  
                if (response.data.addNewPermission.status == 'Failed') {
                  this.StatusFail(response.data.addNewPermission.message)
                }
              }).catch(error => {
                console.log(error)
                this.StatusFail('Failed to Add')
              })

          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
